import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type { GroupInviteLinkShowRouteModel } from 'invite-sign/routes/group-invite/show';

export default class GroupInviteLinkShowExceededRoute extends Route {
  @service declare router: RouterService;

  beforeModel(): void {
    const { groupInviteLink } = <GroupInviteLinkShowRouteModel>this.modelFor('group-invite.show');

    // If the link exists and is not at capacity, redirect back to the fill route
    if (groupInviteLink && !groupInviteLink.isAtCapacity) {
      void this.router.replaceWith('group-invite.show.fill');
    }
  }
}
